<main class="login-layout" [class.tenant-mode]="isTenantMode">
    <div class="left-section" *ngIf="!isTenantMode">
        <div class="image-wrapper relative">
            <img src="assets/images/login-img.png" alt="Ilustración" class="w-full h-auto" />
            <div class="absolute bottom-6 left-6 text-white text-3xl md:text-5xl font-bold leading-tight">
                <div>Mejoramos</div>
                <div>la vida de</div>
                <div>las personas</div>
            </div>
        </div>
    </div>
    <div class="right-section">
        <form [formGroup]="loginForm" (ngSubmit)="onSubmit()" class="login-form">
            <h2 class="text-3xl font-bold">¡Hola de nuevo!</h2>
            <h2 class="txt-h2">Ingresa tu correo electrónico y contraseña para ingresar.</h2>

            <mat-form-field appearance="fill" class="form-field">
                <mat-label>Correo electrónico</mat-label>
                <input matInput type="email" formControlName="email" />
                <mat-error *ngIf="loginForm.get('email')?.hasError('required')">Campo obligatorio</mat-error>
            </mat-form-field>

            <mat-form-field appearance="fill" class="form-field">
                <mat-label>Contraseña</mat-label>
                <input matInput [type]="hide ? 'password' : 'text'" formControlName="password" />
                <mat-error *ngIf="loginForm.get('password')?.hasError('required')">Campo obligatorio</mat-error>
                <button type="button" mat-icon-button matSuffix (click)="hide = !hide"
                    [attr.aria-label]="'Toggle password visibility'">
                    <mat-icon>{{ hide ? 'visibility_off' : 'visibility' }}</mat-icon>
                </button>
            </mat-form-field>

            <div class="text-center">
                <a class="text-xs cursor-pointer hover:underline text-[#CC7D0B] font-bold block"
                    (click)="openForgotPasswordDialog()">
                    ¿Olvidaste tu contraseña?
                </a>
            </div>
            <br>
            <button mat-raised-button class="btn-login" type="submit" [disabled]="loginForm.invalid">
                Iniciar sesión
            </button>
            <button mat-stroked-button class="btn-register" type="button" (click)="goToRegister()">
                Registrarse
            </button>
        </form>
    </div>
</main>